import React from 'react';
import { Typography, TextField, Alert } from '@mui/material';

/**
 * AdvancedSection Component
 *
 * Displays the advanced theme configuration section with raw JSON editor.
 *
 * @param {Object} props
 * @param {Object} props.themeData - Current theme data object
 * @param {Function} props.setThemeData - Function to set theme data directly
 */
function AdvancedSection({ themeData, setThemeData }) {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Advanced Theme Configuration
      </Typography>
      <Alert severity="warning" sx={{ mb: 2 }}>
        This is an advanced feature. Incorrect JSON can break your theme. Make
        sure your JSON is valid before saving.
      </Alert>

      <TextField
        label="Raw Theme JSON"
        multiline
        rows={20}
        value={JSON.stringify(themeData, null, 2)}
        onChange={e => {
          try {
            const parsedJson = JSON.parse(e.target.value);
            setThemeData(parsedJson);
          } catch (error) {
            // Don't update if JSON is invalid
          }
        }}
        fullWidth
        variant="outlined"
        sx={{ fontFamily: 'monospace' }}
      />
    </>
  );
}

export default AdvancedSection;
